import React, { useEffect, useRef } from 'react';
import { useSelector } from "react-redux";
import MasterFilterCalendar from "../../../components/Master/MasterDashboard/MasterFilterCalendar.jsx";
import MasterAmountOverview from "../../../components/Master/MasterDashboard/MasterAmountOverview.jsx";
import MasterRecentTenants from "../../../components/Master/MasterDashboard/MasterRecentTenants.jsx";
import { motion } from 'framer-motion';

export default function MasterDashboard() {
  const masterUser = useSelector(
    (state) => state.masterAuth.masterUser
  );
  const componentRef = useRef(null);

  useEffect(() => {
    if (componentRef.current) {
      componentRef.current.scrollTop = 0;
    }
  }, [masterUser]);

  const fadeIn = {
    hidden: { opacity: 0 , scale: 0.97},
    visible: { opacity: 1 , scale: 1}
  };

  return (
    <motion.div
      ref={componentRef}
      initial="hidden"
      animate="visible"
      variants={fadeIn}
      transition={{ duration: 0.18 }}
    >
      <div className='filter-sec'>
        <MasterFilterCalendar />
      </div>
      <div className='graph-overview1'>
        <MasterAmountOverview />
      </div>
      <div className='recent-invoices'>
        <div className='recent-invoice-inner'>
          <MasterRecentTenants />
        </div>
      </div>
    </motion.div>
  );
}